module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7884/js/img/MarketingHub_Icon.svg"